import TimeStage from './TimeStage'

export default class SpeedStage extends TimeStage  {
  constructor(data, id){
    super(data, id)
    this._id = id
    this._stopOffset = data.stopOffset || 0
    this._speed =  data.speed || false
    this._initialSpeed =  data.initialSpeed || 1
    this._targetSpeed =  data.targetSpeed || 1
    this._decelerate = data.decelerate || false
    this._changeTime = data.changeTime || 1
    this._stopPosition = data.stopPosition || false
    this._startPosition = null
    this._type = 'speed'
  }

  reset() {
    this._isComplete = false
    this._completeTime = 0
  }

  start(position, time) {
    this._isComplete = false
    this._startTime = time
    this._startPosition = position
  }

  updatePosition(position, time, dt) {
    if( this._isComplete) {
      return
    }
    // Work out the speed
    let timeElapsed = time - this._startTime
    let speed = this._speed ? this._speed : this.getCurrentSpeed(time, position)
    // Calculate the new position
    let newPosition = position + dt * speed
    // Handle stopping if a stop position is given
    if (typeof this._stopPosition === 'number') {
      let stopPosition = this._startPosition  +  this._stopPosition + (this._stopOffset || 0)
      if (newPosition >= stopPosition || speed == 0) {
        this.completeCalculation(time - ((stopPosition - newPosition) / speed))

        return  stopPosition

      }
    }
    else if (typeof this._duration === 'number' && timeElapsed >= this._duration) {
      this.completeCalculation(this._startTime + this._duration)
      return position + (dt - (timeElapsed - this._duration)) * speed
    }
    return newPosition
  }

  getCurrentSpeed(time, position) {
    let initialSpeed = this._initialSpeed
    let targetSpeed = this._targetSpeed

    if (typeof initialSpeed === 'number') {
      if (this.decelerate) {
        return initialSpeed + ((targetSpeed - initialSpeed) * this._ease(Math.min(Math.abs((this._startPosition - position) / (this._startPosition - this._stopPosition + (this._stopOffset || 0))), 1)))
      }
      else {
        return initialSpeed + ((targetSpeed - initialSpeed) * this._ease(Math.min((time - this._startTime) / this._changeTime, 1)))
      }
    }
    else {
      return targetSpeed
    }
  }

  completeCalculation(time){
    super.completeCalculation(time)
  }

  set stopOffset(offset){
    this._stopOffset = offset
  }

  set initialSpeed(initialSpeed){
    this._initialSpeed = initialSpeed
  }

  set targetSpeed(targetSpeed){
    this._targetSpeed = targetSpeed
  }

  set decelerate(decelerate){
    this._decelerate = decelerate
  }

  set changeTime(change){
    this._changeTime = change
  }

  set stopPosition(stopPosition){
    this._stopPosition = stopPosition
  }

  get stopOffset(){
    return this._stopOffset
  }

  get initialSpeed(){
    return  this._initialSpeed
  }

  get targetSpeed(){
    return  this._targetSpeed
  }

  get decelerate(){
    return  this._decelerate
  }

  get changeTime(){
    return  this._changeTime
  }

  get stopPosition(){
    return this._stopPosition
  }

  get type(){
    return this._type
  }

}
